
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '@/services/auth/authContext';

interface LogoProps {
  variant?: 'dark' | 'light';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ variant = 'dark', className }) => {
  const { authState } = useAuth();

  // Determine the appropriate home route based on auth state
  const getLogoLink = () => {
    // Check if authState exists before accessing properties
    if (!authState) {
      return '/';
    }

    // If authenticated as restaurant, go to dashboard
    if (authState.isAuthenticated && authState.userType === 'restaurant') {
      return '/restaurant-dashboard';
    }

    // If demo user, go to demo dashboard
    if (authState.isAuthenticated && authState.userType === 'demo') {
      return '/demo-dashboard';
    }

    // Otherwise go to public homepage
    return '/';
  };

  return (
    <Link to={getLogoLink()} className={className || "inline-flex items-center"}>
      <motion.div
        className="flex items-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        whileHover={{ scale: 1.05 }}
      >
        <img
          src="/dineai-logo.png"
          alt="Dine AI Logo"
          className="h-8 w-auto object-contain"
          style={{ imageRendering: '-webkit-optimize-contrast' }}
        />
      </motion.div>
    </Link>
  );
};

export default Logo;
